import axios from 'axios';
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBContainer,
    MDBDateTimepicker,
    MDBIcon,
    MDBInput,
    MDBRow
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useState } from "react";
import GeoMap from "./GeoMap";


import LoginModal from '../login/LoginModal';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
const ContactContent = ({contactPageData}) => {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const { setBasicOpen ,business} = useContext(MiscContext);
    const {tokenLoaded} = useContext(UserProfileContext);
    const {avatar} = useContext(NavbarContext);
    const [conference, isConference]= useState(false);
    const toggleConferenceButton = () =>{
        isConference(!conference);
    }
const[contactAlert,setContactAlert]=useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        email: '',
        subject: '',
        message: '',
        phone: '',
    });

    const handleChange = (e, field) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await axios.post(`${baseUrl}/contacts`, formData);
           
            if (response.status === 200 || response.status === 201) {
setContactAlert(true);
//isContactPage(false)
            }
        } catch (error) {
            // Handle error
        }
    };

    return (
       
        <MDBContainer className="mt-1">  
         <MDBAlert open={contactAlert} autohide  delay={5000} className='w-50' color='success' onClose={() => setContactAlert(false)} z-index='10'>
            <i className="fas fa-check-circle me-3">Thanks for your feedback.</i>
        </MDBAlert>
        {/* {contactAlert && <UserMessagesModal messages={['Thanks for your feedback']} /> } */}
            
            {
                contactPageData?.pageText?.map((textFragment, index) => {
                    return (
                        <p key={index} className="text-center mt-5 mx-auto w-responsive">
                            {textFragment.textValue}
                        </p>
                    )
                })
            }
          
            <MDBRow className="d-flex justify-content-center align-items-center">
            {/* <MDBCol md="2" className="d-flex justify-content-center align-items-center">
          {avatar &&  <img
      src={avatar || contactPageData.image}
      className= 'img-thumbnail mb-2'
      alt='...'
    />}
                </MDBCol> */}
                <MDBCol md="3" >
                    <MDBCard><MDBCardBody>
                    <ul className="list-unstyled mb-0">
                        {
                            contactPageData.contactDetails.map((contactFragment, index) => {
                                return (
                                    <li key={index} className='text-center'>
                                        <MDBIcon icon={contactFragment.icon} className='fas fa-2x text-dark t'/>
                                        {
                                            contactFragment.texts.map((contactText, index) => {
                                                return (
                                                    <p key={index}>{contactText.textValue}</p>
                                                )
                                            })
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul></MDBCardBody>
                    </MDBCard>
                </MDBCol>
                <MDBCol md="7">
                    <MDBCard>
                        <MDBCardBody>
                    <form onSubmit={handleSubmit}>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBInput id="form3Example1" wrapperClass="mb-4" label="First name" onChange={e => handleChange(e, 'firstName')} />
                            </MDBCol>
                            <MDBCol md="6">
                                <MDBInput id="form3Example3" wrapperClass="mb-4" label="Subject" onChange={e => handleChange(e, 'subject')} />

                            </MDBCol>
                        </MDBRow>
                        <MDBRow>  <MDBCol md="6"><MDBInput wrapperClass="mb-4" label='Phone number input' id='typePhone' type='tel' onChange={e => handleChange(e, 'phone')} /></MDBCol>
                            <MDBCol md="6">  <MDBInput type="email" id="form3Example2" wrapperClass="mb-4" label="Email Address" onChange={e => handleChange(e, 'email')} /></MDBCol>
                        </MDBRow>

                        <MDBInput textarea id="form4Example3" rows={4} wrapperClass="mb-6" label="Message" onChange={e => handleChange(e, 'message')} />
                        <MDBRow className="justify-content-between">                            
                            <MDBCol className="mb-2 text-center">
                                {(!tokenLoaded && business!=='B2B')&&  (
                                    <LoginModal
                                        setBasicOpen={setBasicOpen}
                                    />
                                )}
                            </MDBCol>
                        </MDBRow>

                    </form>
                    {conference && 
            <MDBCol className=" justify-content-center align-items-center">
           <p><h3 className='mt-4 justify-content-center text-center text-dark'> <MDBIcon fas icon="video" style={{ color: '#dd4b39' }}/> 30 Minute Video Chat</h3>
<hr />
</p>   
            <p className="d-flex justify-content-center align-items-center">  Conference details will be provided upon confirmation </p>
            <p>These meetings are to explain about product. We will have some conversation on what you really need , some questions, listen, share some insights, and then we determine next steps, if any.</p>



          <MDBRow className=" justify-content-center align-items-center justify-center">
       
          <MDBCol  className=" justify-content-center align-items-center justify-center mb-3">
         <MDBDateTimepicker datepickerOptions={{ format: 'dd-mm-yyyy' }} disableFuture/>
         </MDBCol>
        </MDBRow>
           
            </MDBCol> }  
        {conference ?    <><MDBBtn block size='lg' color='warning'    onClick={toggleConferenceButton}>no call</MDBBtn>  </> :  <MDBBtn block size='lg' color='warning'    onClick={toggleConferenceButton}>a short call ?</MDBBtn>}
        <MDBBtn block size='lg' color='primary'    onClick={(e)=> {handleSubmit(e);}}>{conference ? 'Schedule a call' : 'just Send'}</MDBBtn>
                    </MDBCardBody>
                    </MDBCard>
                </MDBCol>
               

            </MDBRow>
             
                    <GeoMap />
               
            
        </MDBContainer>
       
    );
}
ContactContent.propTypes = {
    contactPageData: PropTypes.object
};

export default ContactContent;